import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const useUpdateSubjectDID = () => {
    const { t } = useTranslation("common", {
        keyPrefix: "update-subject-did",
    });
    const schema = yup
        .object({
            subjectDid: yup.object().shape({
                iri: yup.string().label(t("iri")),
            }),
        })
        .required();

    const form = useForm<yup.InferType<typeof schema>>({
        resolver: yupResolver(schema),
        reValidateMode: "onChange",
        mode: "onChange",
    });

    return {
        form,
    };
};
